import ReactDOM from "react-dom/client";
import { enableReactTracking } from "@legendapp/state/config/enableReactTracking";
import { registerSW } from "virtual:pwa-register";
import { toast } from "sonner";
import { App } from "@/app";

const updateSW = registerSW({
	onNeedRefresh() {
		toast.info("New Version Available", {
			description: "Refresh to install",
			action: {
				label: "Refresh",
				onClick: () => {
					updateSW(true);
				},
			},
			duration: 10000,
			closeButton: false,
			dismissible: false,
			onAutoClose: () => {
				updateSW(true);
			},
		});
	},
	onOfflineReady() {
		toast.success("Ready for Offline", {
			description: "You can now use the app offline",
		});
	},
	onRegisterError(error) {
		toast.error("Service Worker Registration Failed");
	},
});

enableReactTracking({
	warnMissingUse: true
});

const rootElement = document.getElementById("app");
if (!rootElement) throw new Error("Root element not found");

if (!rootElement.innerHTML) {
	const root = ReactDOM.createRoot(rootElement);
	root.render(
		<App />
	);
}
